export default "__VITE_ASSET__e7de3a02__"